"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnSiteOnlyBadge = OnSiteOnlyBadge;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var theme_1 = require("../../theme");
var tokens_1 = require("../../tokens");
var Icons_1 = require("../Icons");
function OnSiteOnlyBadge(_a) {
    var label = _a.label, sx = _a.sx;
    var p = (0, theme_1.useV2Palette)();
    return ((0, jsx_runtime_1.jsx)(material_1.Chip, { icon: (0, jsx_runtime_1.jsx)(Icons_1.MapPinIcon, { sx: { fontSize: 12 } }), label: (0, jsx_runtime_1.jsx)(material_1.Typography, { color: "inherit", display: "block", sx: {
                fontSize: 12,
                lineHeight: '16px',
                fontWeight: tokens_1.fontWeight.semiBold,
            }, children: label }), size: "small", sx: __assign({ borderRadius: "".concat(tokens_1.radius.full, "px"), height: 20, bgcolor: p.background.info.subtle, color: p.foreground.semantic.info, '.MuiChip-icon': {
                color: 'inherit',
                ml: '6px',
                mr: 0,
            }, '.MuiChip-label': {
                pl: 1,
                pr: 1.5,
            } }, sx) }));
}
